import React, {useEffect, useState} from 'react';
import {Link, useHistory, useParams} from "react-router-dom";
import {Row, Col, Card, CardBody, CardTitle,FormGroup,Label,Input, CardSubtitle, UncontrolledTooltip, Modal} from "reactstrap";
import Footer from "../../layout/footer";
import Mainsidebar from "./mainsidebar";
import 'react-fancybox/lib/fancybox.css'
import '../../assets/css/home.css'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import ReactPlayer from 'react-player';
import Iframe from 'react-iframe'
import toastr from "toastr";

const axios = require('axios');

const ListingsDetails = () => {

	const [Details, SetDetails] = useState(false);
	const [loader, Setloader] = useState(true);
	const [data, SetData] = useState({});
	const [error, setboxerror] = useState({});

	let {id} = useParams();


	useEffect(() => {
		getdatatoshow()
	}, []);

		var Detail = Details?Details.amenities:'';
		var Amenitie = Detail.split(",");


	const getdatatoshow = () => {
		axios.get(process.env.REACT_APP_BASE_URL+"auth/listings-detail",{
			params: {
				id: id,
			}
		})
			.then(function (response) {
				if(response.data.error == 0)
					SetDetails(response.data.list)
			})
			.catch(function (error,response) {
				console.log("error",error)
			}) .then(function () {
			Setloader(false)
		});

	};

	const savepost = () => {

		axios.post(process.env.REACT_APP_BASE_URL + "auth/contact-us", data)
			.then(function (response) {
				SetData({});
				toastr.success('Successfully save details ');
				setboxerror({})
			})
			.catch(function (error, response) {
				setboxerror(error.response.data.errors)
			})
			.then(function (response) {
				document.getElementById("myForm").reset();
			});
	}



const manageAmenities = (e, value) => {

	if (e.target.checked === false) {
		SetData({...data, [value]: '0'})
	} else {
		SetData({...data, [value]: '1'})
	}
}


	const customRenderItem = (item, props) => <item.type {...item.props} {...props} />;

	const getVideoThumb = (videoId) => `https://img.youtube.com/vi/${videoId}/default.jpg`;




	// const getVideoId = (url) => url.substr('https://www.youtube.com/embed/'.length, url.length);
	const getVideoId = (url) => url;

	const customRenderThumb = (children) =>
		children.map((item) => {

			const videoId = getVideoId(item.props.url);
			{
				return item.props.type == 'image'?
				 <img style={{'height':'50px'}} src={item.props.url} />:
				 <img style={{'height':'50px'}} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASsAAACoCAMAAACPKThEAAAAkFBMVEX///8aGhrm5ubl5eXk5OTz8/Pj4+P19fXs7Oz5+fn7+/vw8PAAAADt7e3p6ekYGBgRERHR0dG7u7sTExMLCwvZ2dmlpaXLy8uQkJBsbGzAwMCWlpZ0dHRISEgkJCRWVlYzMzM+Pj6CgoKysrKLi4tfX19XV1csLCx7e3tBQUGfn5+pqaljY2NMTEw3NzcuLi7xlfRuAAAShUlEQVR4nO1daWOyuhKOIGuGxQpatbX7Zrf//+9uFkFIAgQIfW3PzZczp319OjNmeTKZTBCibW5ZVkyFkEi2T6XAJhKmkkMlj0qYSgGVYvKBOfuoVUp/H+T8NTwfkPPX8HxA+oLPObg9SsNfCsKaXf6cSlEBbnFwqwS3ii/Cp1JYgNv/EZA5afyXLpH4L6nEfukRyXUYLpU4Lvmly3GpVH7074MwR1rs52WnO/VXj0ocvBzbPu2vDPw0yuf/CZD/+2qor2z+cypFMvhcBLeV4H8WBMW0oTBEIRV8KgVUwlTyqORQCVPJo1JEpYBKPhGskErWfwKEeY9NYcyRbB7kiyyV+MJB50G2cETzYkaMy3nQrs2Ifxuk7HRnywDPB+T8NTwfkOLntgg+r4LPeadVEd3qjPjHQULaYp80KgRUwlTySskhUuxRCfuFFFEpoBL9ZPzfAEG2bRcclUh8faTSkegSiS+yc9suiC6RjkSXSOVHx4OQPs/XGo+0oBgS7j/QRA1yRlzUcxcXu8vHzdvX7X7/8nX39Hh5eFi4Qfjjmpwtb7ctQn6s7eVNCqxl6XKZJMlymfH/Tz8fL8jXTbjPP/cVGYP28edEOnJUIvFOOy87LR2rR3AiHc0kEvuoOxwkCvL3DXVTmsyULWE+3KzywPcm1aQTBEW0BbRRAVPBq0sOlRwqeVTCpVT/6BAQotbuhXSlBjdVHEY6WfK4IDpPpIkOCCocWXBUIh2JLpH4Iku/jSPRLWbEuJwHab90h4GE7m4PsOzyU+kv0r0ecz7pG9ZEE6Q+LH+SAW6fSV/RdVTprs8L85qcN29H6H0PaT9H8ZbC8vBPfeUWU1hIJ7Mj0VV02nJGPM2DVrXT6oFYPt71GHuKzrXD2DKhSU9zKO/zMG0KyaGCU5daP6AD4gW73oNPaACXjjdek57msMmsmeieFtl5ucieiG7tO9AEsdB2P9JTzFvJAyffwzXpbc5Pc1Gcfxrw1IyOxK8c/2Xebnk7yEx4irYU7nH847y97G8njtrSaWtEV9Fpm0HC/BZMeYo22C/wME0GmYMc2thMN0zyalLrB9DD8MVP3ZZwQEM0GWYOqruvQnRVi+y8usgqiG4bSBxdGe1UvMFTHPfVZLA59WE5HReN8pcJXEXH4Rr/Md6uPf6WaZpmpJH/aH4A3p2f9NX0Y3DVzRR4wOr28+bm4+rq4/nm85aFs7o9Bvd9NBlhTjezbWS7TbxX/gB67Bh/1E93m9UFj4KyeDf5jxdfrDZv3f6CV+RoE/Xh5vwIZ/DaZ3Wywfu6usAR9mNL+EpjH2P/4vWrY/sIH471A5zhB7gofmpzVQb7e7cLJN69tJJY+IwsDU3Onrej5xZXAVxtHb8bJMTr17YdN7xF0/tq+r1z8wAkg+8xxrHetteKrLb4BDzrgIzbO58ms0CWnKA6Dwbl7BfguqT4aCGh+0ZXAez8INAB4ZoEIT6kzWhXSAdkhDmodOQ0sT5n12RcCo84svqF6ezIad58w6s3cayvPixNc9HoocFVCVxb3pDwb2TdNA1E2OFfzNvDRYOrMrgYGioP0Lapa8E2nt5XYw6JalkAIkjDyR9chz1AZE0aSEgC8aTmnM4N/fLcsCb5/PCRSuXho18ePvrlR2UQHz0pO0ACl6E2iFKT8KDmpukb8iczJ5ryjB4flF9/Cgs+rY44Xkf5TPk1wKMz4Rn9dFw0Vk9W2YtjJG1DHWKFrf8beXukzOaAr54aNmpyrXIWmbKm85XijklQu5RREN2elzIC51VlC3yiPiCtmmyUf2DjTWIOvWNS5PvFZb5fXCYNxmLSYFykCkal5MeVpMEKiJOrLUF9QFo18dVbAtiiCcxhOZBFVzOdjBrcKlYq2qvMpcWGyp6VzOgVrUlya+vD0hh5i1RrYHbXD6RbE9WcBZf4d/F2X7ERSW9D075CdwrqAO6kvF19KcMdfCkDKyb2BKx+IDqaBIk81LMrz7A5RxB+d4n+yGL3dCiuxS77kOZZ7LIP/Q7oxR7+F6gUFB/lS6slgviqsbEN+oHoaBKpSBy4hs3hII134hSEpMclMkV8D+4HXmdr1wQpgj7Zh2FzOMg0XDSS9U+vG0HiceHfG3nKoh3rt/B2mfiwyUoNEl/cj/KVJy8j2eaneDudzNyS6Pa/TO2HsvZwaASxLiB9kEB6aHKhGPDYnDklCKq7j96vt8tL+gMXWcUUsrzFzSALSOBt7QzWxHmTsnQJxzJmzglE+HknIdEo/oBepHUctnEzCF3KUrgKhmqiCGgks8iYOZNyUVl1Mn+0gPB/n7FhOkgTR54fya7QlDmT+mojLUzge52+Iv9quWVwvTWx5Ok9fZ7KV65dclS7JLr2vAxQl0TXLomuXRLdQipA5CA76VZtIGU/JNNW7lhDNJFzSwAbMqcCYnwdtORlCXK7BaT6gRTuwwGaxK78N1ex8XXQOL9yPsQhmG28NpC45lyAdwbcTxPvSvyj6ad3/lw0loYgLGJ9X5GBeLt1YrunJnJkkUYbpvRV+wZKCzzeilovv7xWkFgctEt4yrHfSxPbuxE5FjzEBsxR7wdDKhz31NaxVhQ9RbeOafx0uaFSRKUS/FQrioPYWFq/YeW3gki+ovzhHvfTJJaSAbKNM96cmk/Y73pFjThuc8DnTiSibEVqA1GGVdJ3HLs9NAlE2pDsjZhTBSk7nSF+hUXDOdNpA1GeIyZwt3b6bE+k2Z3s1s+ci66lIfgwyFd02tq4PTSRUMgf/ic1Uuzmg48qOAGR9s3gd4E0JdOQaWunr4k0CLNXA+bUfMLPwo5lnkJWKypC7ECtqBrllLWiWNUoeozGq0axzOqiflYBIq5Hyy/6yzaQZl/RaWtbqV/Vrsm18JfTazTenKpPus+d3V4HtfFe+HbhMewAUayDp5bA9UJPk1g8ZUuyeLQ59XNnw1xU2mzAOugAafUVi9ZgHU1iiY5C7o81Z1LeLjFRcLpAOnzFcnB5wK1VExuJExY8RGPNkXxlq3h7kSmte/BxBHkXB8KsE6TTV2Qg7um2p0uTb4HZwQqPNafO2/2yzBMVIpYn4ZdVo6jksIwJKpVVo/ygqBrFPhqWIEicNLIn1AWCpb4otyV85kHUrol0IpK9BiPNqfuEea87wbIM+HQkWGKREdJk/y6QlnXw1FIglpMpt1mTWKQr6Q0aac6kNVIckTLAKu4E0fIVnbYOTtyiibRrJ76yz5i3y75aG/MVmbZetp7V7Ctxy7D8Dqfwlfqigd3rogH7gLhzhoXVCaLrKzpt3eSoURORryTg2ePMEX2iVyvKqdeKwg21oiIx0Acu7gIJpS1kS0vpJdQGTaRtO0Qjzan7pM89r9ZigBzEk+lVJ0g3Z6gjwiqw1JpIBGusOZPWSHGkfUY3SE9fkaH1vUZKTRp8daa8XRwGU/iKTlsf+F/4SvfeROcF4WZfdYD09xWN1qwUmkj79vlIc4R7E0ZrRQVi4lWSok4QR4O3C41QLcXfRzPRV34wyhxBQnVHdhc0aC0GaFtSv3K6QfQ5A28ZvEaRQhMp2gfs2s0Yc+o+qQ/LsVzUX4rqFq+HGOCivBGO5ao1UfjKOmPe7ktThmvWVwnsL5o0kfnVFL6q3e0dU1TE+RT3OLnE2yWQHr4C2IVNmljSBLAPRpoj+MQx2pDsK6/rM4E2b6ch0rARxxMDo+l18z8eZFyNt2sVFSmJrqqoiHgTFbadILqcIYHPvFUTsX+mN95YcyatkSLG22BniovC7CFs10SKM268seZMGm9fifpemfFVBpe+36GJmLAGO2zWV6q984hOK6ZgLPcmxiA9gsadmkixs/dorDk1n6jq1o6pFSWT0aALpHNuT+B2HXZrgqR40CIYaU7dJ6h0pCLWN2CRlZJFgSeuj+AMACsv1tBEPh/00Fhz6j6pD8vxyRLiSTnsvC6QVl9l8Oj7WpqIx23Lu3PPkxEXwpRfBh/oqyU8x0hTEzFVPHs6uxop1U5LQMTJPcm8LpBmX8HLQl8TscQBrEy/C8CLO7GwclXioWaHSk4pHWPTpURaEeouPorlhIYct4M0xmTIRBU62prI09VivDk1yXCsD82jb/HrfcWDYn308BTpaxJdSqc4BTUyFuszzEXnjjhtJOAP4KIJXLu9NPHECEf67PVN/P7p/HY5IRgu2p8BUvkK9tt+mkgHqTM4+BPUNjT6AJZ0ojnLPrx5vzOvDHb8NRp9TfCrlFqbW6bf8+Jlnlg6SCHhkBV8ojklvFYUzSlhs18hHbNLqMSzSyogEsOaAQFsARHPUlPYYNRTk1DiwMtbZMScCgjiXW3cGf28BiJun2msQf+MPoG3xQBN5JF/acicSWsbSrUZEgh0uWgCywfPH6DJXrqB4BoyZ9q7lmJslF4M1/MVwCX2pexxDU2kbkWG4ES+MvtwraR4suQpwA0gha+WcIWjYZpIN6zZhWDT7/DGRWo3S+iOwiKh+1g1ihYV4bWiaFZ4KR1rRVU/Wko+lgqqwSFsBok4b0/gax34gzSRv50ZxL4hc04gpnNr2Qekq14Ju7/UmlsL8O7EAzUJpS8n25gzZ9IaKZEY8GPFihtBqK8yuEf+YE0U1+gXv6ZGilxXFBZtvoKN1ahhtybynVQaCJrAV7p3THpdppajLMvvRpD4IVuoQLQ1kcgvq85g0JwjCPtJveCTxXGpxBcOq6gVha2iVpRvsXfuEVJXjQok2jCDe6cJJOZFqAZq4ogBBvrFYKPmFCBFV9NhNdqXyOSdLN1C+8NuorVrorpJQHbrRs2ZkIsSEE8uSpUA7/S9GWC7JlEi1URK3zzD5kzqK1V93/QLTeArVaUwWuhnMl/p3g13tS9TO9L144I49ADR0ERRjjV79oybw0E6Y8jFIqsOup725AKImJHMnHXv9QPp0gSrXmgAtx+ItibKWhbjCAkHkTIxmBkHLLHlNpAOTbDqhQZ4xBOYM22dbU+udkZXKOz1AWnVxFMdAC2/vd9Xk1xR4mVWVCAw4yvlWRks4sl8NShXTecBLFc5mbAgqT5ImybKJ1II5Z3GnPnxJxOsgwzkRmnNVWBiHfRkuj4reMlE5qB6VzNMSKTILnPWJrJG8ytH+fIVjVZPaM6kvlJOWTPY80uAI3zlqh8U5RUNz8JXnRsoCVz9kskS3nuAKDTZqp98OVYVnc6c4l8c99SkHTfmVnHlgUrHjTlpx425VakaZTWCBMo3Ieg4dPRBRE1C5UsWBPQmsCc1Z5L4VQXks8GuY/GEPm9zcE3Ch4a34tirA4ODYP+gRooMoqrcP2P1rXJ9kJMmbtPTZ9mtPsi5cdECJPxqeKkshSu3n6885N83vXu2TPFP+Krl9KQG3vvgg4NEjQ81Z7BxvVgLhGgS4/wVmlIAE8i1QEad49QLPmkcqEXlqVx5oNYOEuSg2BkW3nraYsfvBvGwt940eoqsrAusATLOHOY9w+fOEoj/0vyGbgb7Rxf7lt0MMrd8J7/8bnmIN1u6epqMM6c+LCd6Yz28ay0HBl+X69hrAkHxdnfX+sBz9h3panK+vP0EotwaVoYQZG+HnKzdmL4MxT1Ek56QlR8+l10vYb+FPTSZtkaKPThh6QSifqis2rtSIC75/tjtDg/rPF8/rHa7q+89+aHyubmqq55xH03GmFPNYQvLHLaiVhSRjrWiivQ3JkVlIpwvJcKpQYKGpyjrDqPv0p9aJt6eVn0EHoN+mgw2x3i+aDNI3vw28/CWwbq/JkPzRSfnohWQ1nfpBzX4dAZpcqa8vQKCDs1Ma0hbwqU3NhD9gzVS5kVX1QKJ8i+DXQte1o47UJMh5pzeLPbkgk+VWlFOvVZUU9WoLhCM3lsoZa9GCwDj4ZoMMAcVjjR1z6sTxP8wMRBZ9Y+RmvQ2pz4sJ+OiFRBv/TnWW0u42wbjg/ZnyturIHG4vRvjrRRuL4LYZALJ4BopuheEOWSt0+qCWIj0rYa36rtaBtdbDmdCk14gw+7Rd1eN6gAJ0OIK+ncusjX8WKPQpCb6IH1qG/YraNAFEmPn4a1jVyw56naFQ8u0JrogP8pFZZD57rZ7c0wb3VrfXrrTaXJuvF0F4uWrp5Ruk1v6E91Q3xxyp6OezOS+GpT7oVnYRweE6OJY+fvmjgUW0mpkIVmmLOxw9/GeR15sTaxJd+6H0QpRQ5sXhKGbv68213f7U0hmdve5Wb0v6E1Kr7OK1g80VHdfd21DnaIig0D4F4l9y3XpbsN3LR8H/0STRhDWfpaLaoEYLif+W3n7rwVhrUenbS/I+bdBJme7fwekMq3W4loti2wtOCYusn8Z5J9z0V8E8n9fDeXto98F+NMguu9NdMem/z7I/wCVqPh9dIXoaAAAAABJRU5ErkJggg==" />
			}

		});

	return (
		<>

			<div className="fixed-top-1">
				<Mainsidebar homepage={false} expanded = {false}/>
			</div>

			<section id="hero1">
				{/* top item start */}
				<div className="container space-otherpage-top">
					<div className="lending-header">
						<h1 className="lending-header-h1">LISTINGS </h1>
					</div>
					{
						Details ?
						<div className="row  space-otherpage-top pb-5">
							<div className="col-lg-4">
								<h5 className="font-size-20 font-weight-bold  text-dark pr-4 mr-4 pl-3 text">
									{Details.address}
								</h5>
								<h5 className="font-size-20 font-weight-bold  text-dark pr-4 mr-4 pl-3 text">
									{Details.city} {Details.state} {Details.zip_code}
								</h5>
							<h5 className="font-size-20 font-weight-bold text-center mt-4 text-dark">Property</h5>
								<div className="solid" />
								<div className="Property-text ">
									<table className="table table-borderless">
										<tr className="d-flex">
											<td className="col-4 p-0"><h6 className="font-size-16 ml-3  font-weight-bold">Furnished: </h6></td>
											<td className="col-8 p-0"><h6 className="font-size-16 text-center font-weight-bold">{Details.furnished}</h6></td>
										</tr>
										<tr className="d-flex">
											<td className="col-4 p-0"><h6 className="font-size-16 ml-3 font-weight-bold">Ownership:</h6></td>
											<td className="col-8 p-0"><h6 className="font-size-16 text-center font-weight-bold">{Details.furnished}</h6></td>
										</tr>
										<tr className="d-flex">
											<td className="col-4 p-0"><h6 className="font-size-16 ml-3 font-weight-bold">Type:</h6></td>
											<td className="col-8 p-0"><h6 className="font-size-16 text-center font-weight-bold">{Details.type}</h6></td>
										</tr>
										<tr className="d-flex">
											<td className="col-4 p-0"><h6 className="font-size-16 ml-3 font-weight-bold">Bedrooms:</h6></td>
											<td className="col-8 p-0"><h6 className="font-size-16 text-center font-weight-bold">{Details.bedrooms}</h6></td>
										</tr>
										<tr className="d-flex">
											<td className="col-4 p-0"><h6 className="font-size-16 ml-3 font-weight-bold">Bathrooms:</h6></td>
											<td className="col-8 p-0"><h6 className="font-size-16 text-center font-weight-bold">{Details.bathrooms}</h6></td>
										</tr>
										<tr className="d-flex">
											<td className="col-4 p-0"><h6 className="font-size-16 ml-3 font-weight-bold">Area:</h6></td>
											<td className="col-8 p-0"><h6 className="font-size-16 text-center font-weight-bold">{Details.area}</h6></td>
										</tr>
										<tr className="d-flex">
											<td className="col-4 p-0"><h6 className="font-size-16 ml-3 font-weight-bold">Lot Size:</h6></td>
											<td className="col-8 p-0"><h6 className="font-size-16 text-center font-weight-bold">{Details.lot_size}</h6></td>
										</tr>
									</table>
										</div>

								<h5 className="Financials-heading font-size-20 font-weight-bold text-center text-dark">Financials</h5>
								<div className="solid" />
								<div className="Property-text">
									<table className="table table-borderless">
										<tr className="d-flex">
											<td className="col-4 p-0"><h6 className="font-size-16 text-center font-weight-bold">Price:</h6></td>
											<td className="col-8 p-0" ><h6 className="font-size-16 text-center font-weight-bold">${Details.price}</h6></td>
										</tr>
										<tr className="d-flex">

											<td className="col-12 " colspan="2">
												<form id="myForm" className="contact-form contact-form-color px-4" onSubmit={(event)=>{event.preventDefault();savepost()}} method="post" >
													<h5>Contact</h5>

													<div className="form-group contact-group">
														<ul>
															{
																Object.entries(error||{}).map(function ([index, value]) {
																	return <li className="text-danger text-left">{value[0]}</li>
																})
															}
														</ul>
													</div>

													<div className="form-group contact-group">
														<input
															type="email"
															className="form-control contact-form-group"
															placeholder="Email"
															defaultValue={data.email}
															onBlur={(event)=>{SetData({ ...data, ['email']: event.target.value })}}
														/>
													</div>
													<div className="form-group contact-group">
														<input
															type="Name"
															className="form-control contact-form-group "
															placeholder="First Name"
															defaultValue={data.first_name}
															onBlur={(event)=>{SetData({ ...data, ['first_name']: event.target.value })}}
														/>
													</div>
													<div className="form-group contact-group">
														<input
															type="Name"
															className="form-control contact-form-group"
															placeholder="Last Name"
															defaultValue={data.last_name}
															onBlur={(event)=>{SetData({ ...data, ['last_name']: event.target.value })}}

														/>
													</div>
													<div className="form-group contact-group">
														<input
															type="Name"
															className="form-control contact-form-group"
															placeholder="phone"
															defaultValue={data.phone}
															onBlur={(event)=>{SetData({ ...data, ['phone']: event.target.value })}}

														/>
													</div>
													<div className="form-group contact-group1">
														<div className="form-check">
															<input
																type="checkbox"
																className="form-check-input"
																id="dropdownCheck"
																onChange={(e)=>{manageAmenities(e,'schedule')}}

															/>
															<label
																className="form-check-label contact-form-text"
																htmlFor="dropdownCheck"
															>
																schedule a showing{" "}
															</label>
														</div>
													</div>
													<div className="form-group contact-group">
														<div className="form-check">
															<input
																type="checkbox"
																className="form-check-input"
																id="dropdownCheck2"
																onChange={(e)=>{manageAmenities(e,'requests')}}
															/>
															<label
																className="form-check-label contact-form-text"
																htmlFor="dropdownCheck2"
															>
																request more information{" "}
															</label>
														</div>
													</div>
													<div className="form-group contact-group">
													<textarea
														className="form-control contact-form-group"
														rows={3}
														placeholder="Enter Message"
														defaultValue={data.message}
														onBlur={(event)=>{SetData({ ...data, ['message']: event.target.value })}}

													/>
													</div>
													<div style={{width:'100%'}}>
														<button style={{display:'block',margin:'0 auto'}} type="submit"  className="btn btn-dark center">
															Send
														</button>
													</div>
												</form>
											</td>
										</tr>
									</table>
								</div>



							</div>
							<div className="col-lg-8">
								<h4>{Details.title}</h4>
								<div className="my-3">
									<div className="Custome-Carousel">

									<Carousel
										renderItem={customRenderItem}
										renderThumbs={customRenderThumb}
										showStatus={false}
										showIndicators={false}
										showArrows={false}
									>

										{Object.entries(JSON.parse(Details.images)|| {}).map(function ([index,value]) {
											return <div url={value.url} type={value.type}>
												{value.type == 'image'?
													<img key={index} type={value.type} url={value.url} src={value.url}/>
													:
													<ReactPlayer key={index}
																 type={value.type}
																 url={value.url}
																 width='100%'
																 height="400px"
																 className='mt-2'
																  />
												}


											</div>
										})}
									</Carousel>
								</div>

								</div>


								<div className="solid" />
								<div
									id="map-container-google-1"
									className="z-depth-1-half map-container custom-map-container blog2"
								>
									<iframe
										src="https://maps.google.com/maps?q=manhatan&t=&z=13&ie=UTF8&iwloc=&output=embed"
										frameBorder={0}
										style={{ border: 0 }}
										allowFullScreen
									/>
								</div>
								<div className="description-text">
									<h5 className="font-size-20 font-weight-bold text-dark">Description</h5>
									<div className="solid" />
									<div style={{'fontSize': 16}}>
										{Details.description}
									</div>
								</div>
								{/*<div className="description-text">
									<a target="_blank" href={Details.video_link}>{Details.video_link}</a>
								</div>*/}
								<div className="Amenities-group">
									<h5 className="font-size-20 font-weight-bold text-dark">Amenities</h5>
									<div className="solid" />

									{Object.entries(Amenitie|| {}).map(function ([key,value]) {
										return <div className="Amenities-text">
											<p className="font-size-16"> {value}</p>
										</div>
									})}

								</div>
							</div>
						</div>
							:

							<div className="row pt-5 pb-5 listings-filter equal">
							<div className="col-sm-12 ">
								<hr/>
								<h4 className="text-dark text-center font-size-30 font-weight-bold">No Result  Found...</h4>
								<hr/>
							</div>
							</div>
						}

				</div>
			</section>
			<Footer/>

		</>
	)
};


export default ListingsDetails ;
